import { useEffect } from 'react';
import { useDisclosure } from 'ui';
import { useIsSessionActive } from './useIsSessionActive';

export const useModalDisclosure = (options) => {
  const {
    onOpen,
    isOpen,
    onClose,
    onToggle,
  } = useDisclosure(options);
  const { hasExpiredSession } = useIsSessionActive();
  useEffect(() => {
    if (hasExpiredSession) onClose();
  }, [onClose, hasExpiredSession]);

  return {
    onOpen,
    isOpen,
    onClose,
    onToggle,
  };
};
